module.exports = __webpack_public_path__ + "static/media/profile-danny.b2ee4369.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/profile-danny.JPG
// module id = 319
// module chunks = 0